import { SelectOption } from '@property.com.au/ui-kit';
import {
  SearchPageSortOptionForAllPropertyStatusesValue,
  SearchPageSortOptionForRentValue,
  SearchPageSortOptionForSaleValue,
  SearchPageSortOptionOffMarketValue,
  SearchPageSortOptionSoldValue,
  SearchPropertyStatus,
} from '../types';

export const SEARCH_PROPERTY_STATUS_DEFAULT = SearchPropertyStatus.forSale;

export const SEARCH_API_SORT_OPTION_VALUE_BY_PROPERTY_STATUS_DEFAULT: {
  OFF_MARKET: SearchPageSortOptionOffMarketValue;
  ALL: SearchPageSortOptionForAllPropertyStatusesValue;
  SOLD: SearchPageSortOptionSoldValue;
  FOR_SALE: SearchPageSortOptionForSaleValue;
  FOR_RENT: SearchPageSortOptionForRentValue;
} = {
  OFF_MARKET: 'RELEVANCE',
  ALL: 'RELEVANCE',
  SOLD: 'NEW_DESC',
  FOR_SALE: 'RELEVANCE',
  FOR_RENT: 'RELEVANCE',
} as const;

export const SEARCH_API_SORT_OPTION_LABEL_BY_PROPERTY_STATUS_DEFAULT = {
  OFF_MARKET: 'Relevancy',
  ALL: 'Relevancy',
  SOLD: 'Date (Newest - Oldest)',
  FOR_SALE: 'Relevancy',
  FOR_RENT: 'Relevancy',
} as const;

export const GEO_SHAPE_SEARCH_SOLD_SORT_OPTION_LABEL_DEFAULT = 'Relevancy';
export const GEO_SHAPE_SEARCH_SOLD_SORT_OPTION_VALUE_DEFAULT = 'RELEVANCE';

export const SEARCH_SEPARATOR = '|';

export const SEARCH_LOCATION_DEFAULT = 'Australia';

export const SEARCH_BOUNDING_BOX_DEFAULT = '';

export const SEARCH_POLYGONS_DEFAULT = '';

export const SEARCH_SURROUNDING_SUBURBS_DEFAULT = 'true';

export const SEARCH_PROPERTY_TYPE_DEFAULT_ITEM = 'ALL';
export const SEARCH_PROPERTY_TYPES_OFF_MARKET_DEFAULT_SELECT_OPTION: SelectOption = {
  label: 'House',
  value: 'HOUSE',
};

export const SEARCH_MIN_BEDROOMS_DEFAULT = '0';
export const SEARCH_MIN_BATHROOMS_DEFAULT = '0';
export const SEARCH_MIN_CAR_SPACES_DEFAULT = '0';
export const SEARCH_PAGE_NUMBER_DEFAULT = '';

export const SEARCH_KEYWORDS_DEFAULT = '';
export const SEARCH_KEYWORDS_SEPARATOR = ',';

export const SEARCH_EXCLUDE_UNDER_OFFER_DEFAULT = 'false';
export const SEARCH_EXCLUDE_DEPOSIT_TAKEN_DEFAULT = 'true';
export const SEARCH_HAS_IMAGES_DEFAULT = 'true';
export const SEARCH_MIN_LAND_SIZE_DEFAULT = '0';

export const SEARCH_PROPERTY_FEATURES_DEFAULT_ITEM = 'ANY';

export const SEARCH_FLOW_DEFAULT = 'location';
export const SEARCH_COMMUTES_DEFAULT = '';

export const SEARCH_MIN_PRICE_DEFAULT = '0';
export const SEARCH_MAX_PRICE_DEFAULT = '0';

export const SEARCH_VIEW_DEFAULT = 'map-list';

export const AUSTRALIA_BOUNDING_BOX = [
  -13.396255035583252, 107.10989201592761, -43.37807010450115, 157.5151654534276,
];
